<template>
    <div>
        <div class="form-card">
            <form class="sp-form">
                <h6>Add New Category</h6>
                <div class="form-group" v-if="categories.length > 0">
                  <label>Select Main Category Group</label>
                  <select class="form-control" v-model="main_category" @change="resetSetCategories(); getMainCategories(main_category.category_id)" >
                      <option :value="undefined">Select</option>
                      <option v-for="ct in categories" :value="ct" :key="ct.category_id">{{ct.category_name}}</option>
                  </select>
                </div>
                <div class="form-group" v-if="Object.keys(main_categories).length > 0">
                  <label>Pick a Category from {{main_category.category_name}}</label>
                  <select class="form-control" v-model="category" @change="getSubCategories(category)" >
                      <option :value="undefined">Select</option>
                      <option v-for="ct in main_categories" :value="ct" :key="ct.category_id">{{ct.category_name}}</option>
                  </select>
                </div>
                <div class="form-group" v-if="sub_categories.length > 0">
                    <label>Select a Category under {{category.category_name}}</label>
                    <select class="form-control" v-model="category.new_category" style="height: 30px; width:245px;">
                      <option :value="undefined">Select</option>
                      <option v-for="ct in sub_categories" :value="ct.sub_category_id" :key="ct.sub_category_id">{{ct.sub_category_name}}</option>
                    </select> 
                </div>
                <br>
                <label v-if="categories.length != 0"><b>OR</b> Add any other category<br></label>
                <div class="form-group">
                  <input class="form-control" v-model="category.new_listed_category" @change="resetCategoriesSelections" type="text" placeholder="Enter Category Name"/>
                </div>
                <br>
                <div class="form-group">
                  <p style="color:#084c8b;">{{data_processing_message}}</p>
                  <p style="color:#ff0000;">{{data_error_message}}</p>
                  <div class="loading-sm" v-if="action_loading"></div>
                  <button type="button" :disabled="disable_btn" class="btn sp-button-02" @click="addProductCategory">Add Category</button>
                </div>
              </form>
            </div>
    </div>
</template>

<script>
    //import sellpoint from "../../../../router/sellpoint";
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
                user:this.$store.getters['account/getUser'],
                business:this.$store.getters['account/getUserBusiness'],
            }
        },

        methods: {
            setPage(){
                this.loading = false;
                this.getCategories();
                //this.getMainCategories(this.sellpoint.business_category_id);
                
            },
        },

        components: {},

        created: function(){
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                    self.setPage();
                }else{}
            });
        }

    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// AddCategory.vue?abc101d2